import { guid } from "@buildwithflux/shared";
/**
 * Fundamental project invite creation function.  Creates invite for any user
 * with the invite uid to join a specific document with predefined permissions.
 *
 * QUESTION: create a mockProjectInvite function? see DocumentInvite.stories.tsx
 */
export function createProjectInvite(documentUid, permission, inviterUserData, inviteeEmail, documentName, organizationUid) {
    return {
        uid: guid(),
        invitee_email: inviteeEmail,
        permission_type: permission,
        document_uid: documentUid,
        document_name: documentName,
        inviter_uid: inviterUserData.uid,
        inviter_handle: inviterUserData.handle,
        inviter_name: inviterUserData.full_name,
        inviter_email: inviterUserData.email,
        created_at: new Date().getTime(),
        updated_at: new Date().getTime(),
        status: "created",
        organization_uid: organizationUid,
    };
}
//# sourceMappingURL=create.js.map